(function (window, document) {
  'use strict';

  var P = window.Printara;
  if (!P) return;

  function parsePanelSize(value) {
    var matches = String(value || '')
      .replace(/,/g, '')
      .match(/-?\d+(?:\.\d+)?/g);

    if (!matches || matches.length < 2) return null;

    return {
      width: parseFloat(matches[0]),
      height: parseFloat(matches[1])
    };
  }

  function getScaledBoxSize(width, height, isMobile) {
    var maxWidth = isMobile ? 72 : 90;
    var maxHeight = isMobile ? 94 : 116;
    var minDimension = 24;

    if (!width || !height) {
      return { width: 70, height: 70 };
    }

    var scale = Math.min(maxWidth / width, maxHeight / height);
    var scaledWidth = width * scale;
    var scaledHeight = height * scale;

    if (scaledWidth < minDimension) {
      var widthBoost = minDimension / scaledWidth;
      scaledWidth *= widthBoost;
      scaledHeight = Math.min(maxHeight, scaledHeight * widthBoost);
    }

    if (scaledHeight < minDimension) {
      var heightBoost = minDimension / scaledHeight;
      scaledHeight *= heightBoost;
      scaledWidth = Math.min(maxWidth, scaledWidth * heightBoost);
    }

    return {
      width: Math.max(minDimension, Math.round(scaledWidth)),
      height: Math.max(minDimension, Math.round(scaledHeight))
    };
  }

  function createVisualizer(calcRoot) {
    if (!calcRoot || calcRoot.dataset.gkPanelVisualizerReady === 'true') return;

    var key = calcRoot.dataset.gkKey;
    if (!key) return;

    var panelSummary = document.getElementById('gk-panel-summary-' + key);
    var panelCount = document.getElementById('gk-panel-count-' + key);
    var panelSize = document.getElementById('gk-panel-size-' + key);
    var panelLast = document.getElementById('gk-panel-last-' + key);
    var panelDirection = document.getElementById('gk-panel-direction-' + key);

    if (!panelSummary || !panelCount || !panelSize) return;

    calcRoot.dataset.gkPanelVisualizerReady = 'true';

    var visualizer = document.createElement('div');
    visualizer.className = 'gk-panel-visualizer';
    visualizer.setAttribute('aria-live', 'polite');
    visualizer.innerHTML =
      '<div class="gk-panel-visualizer__header">' +
        '<h4 class="gk-panel-visualizer__title">Panels You Will Receive</h4>' +
        '<span class="gk-panel-visualizer__count"></span>' +
      '</div>' +
      '<div class="gk-panel-visualizer__viewport">' +
        '<button type="button" class="gk-panel-visualizer__nav gk-panel-visualizer__nav--prev" aria-label="Previous panels">‹</button>' +
        '<div class="gk-panel-visualizer__list"></div>' +
        '<button type="button" class="gk-panel-visualizer__nav gk-panel-visualizer__nav--next" aria-label="Next panels">›</button>' +
      '</div>' +
      '<p class="gk-panel-visualizer__note">' +
        'Panels are shown in their installed orientation and in proportion to the calculated dimensions.' +
      '</p>';

    panelSummary.appendChild(visualizer);

    var countText = visualizer.querySelector('.gk-panel-visualizer__count');
    var list = visualizer.querySelector('.gk-panel-visualizer__list');
    var prev = visualizer.querySelector('.gk-panel-visualizer__nav--prev');
    var next = visualizer.querySelector('.gk-panel-visualizer__nav--next');

    function updateNav() {
      var overflow = list.scrollWidth > list.clientWidth + 2;

      prev.hidden = !overflow;
      next.hidden = !overflow;

      if (!overflow) return;

      prev.disabled = list.scrollLeft <= 2;
      next.disabled =
        list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }

    prev.addEventListener('click', function () {
      list.scrollBy({
        left: -Math.max(160, list.clientWidth * 0.82),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', function () {
      list.scrollBy({
        left: Math.max(160, list.clientWidth * 0.82),
        behavior: 'smooth'
      });
    });

    list.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateNav);
    });

    function render() {
      var summaryVisible = panelSummary.classList.contains('is-visible');
      var quantity = Math.max(
        0,
        Math.floor(P.util.parseNumber(panelCount.textContent) || 0)
      );
      var standardSize = parsePanelSize(panelSize.textContent);
      var lastCoverage =
        panelLast && !panelLast.hidden
          ? P.util.parseNumber(panelLast.textContent)
          : null;

      if (!summaryVisible || !quantity || !standardSize) {
        visualizer.classList.remove('is-visible');
        list.innerHTML = '';
        countText.textContent = '';
        updateNav();
        return;
      }

      visualizer.classList.add('is-visible');
      list.innerHTML = '';

      var orientation = panelDirection
        ? String(panelDirection.textContent || '').trim()
        : '';

      var isHorizontal =
        orientation.toLowerCase().indexOf('horizontal') !== -1;

      countText.textContent =
        quantity +
        (quantity === 1 ? ' panel' : ' panels') +
        (orientation ? ' · ' + orientation : '');

      visualizer.classList.toggle('is-horizontal', isHorizontal);
      visualizer.classList.toggle('is-vertical', !isHorizontal);

      var isMobile = window.matchMedia('(max-width: 520px)').matches;

      for (var i = 0; i < quantity; i += 1) {
        var reducedLast =
          i === quantity - 1 &&
          lastCoverage &&
          lastCoverage > 0 &&
          lastCoverage < standardSize.width;

        var coverage = reducedLast ? lastCoverage : standardSize.width;
        var length = standardSize.height;
        var visualWidth = isHorizontal ? length : coverage;
        var visualHeight = isHorizontal ? coverage : length;
        var boxSize = getScaledBoxSize(visualWidth, visualHeight, isMobile);

        var item = document.createElement('div');
        item.className = 'gk-panel-visualizer__item';

        var boxWrap = document.createElement('div');
        boxWrap.className = 'gk-panel-visualizer__box-wrap';

        var box = document.createElement('div');
        box.className = 'gk-panel-visualizer__box';
        box.style.setProperty('width', boxSize.width + 'px', 'important');
        box.style.setProperty('height', boxSize.height + 'px', 'important');
        box.setAttribute(
          'aria-label',
          'Panel ' + (i + 1) + ': ' +
          P.util.formatNumber(visualWidth) + ' inches wide by ' +
          P.util.formatNumber(visualHeight) + ' inches high'
        );

        var number = document.createElement('span');
        number.className = 'gk-panel-visualizer__number';
        number.textContent = 'Panel ' + (i + 1);

        var size = document.createElement('span');
        size.className = 'gk-panel-visualizer__size';
        size.textContent =
          P.util.formatNumber(visualWidth) + '″ × ' +
          P.util.formatNumber(visualHeight) + '″';

        boxWrap.appendChild(box);
        item.appendChild(boxWrap);
        item.appendChild(number);
        item.appendChild(size);
        list.appendChild(item);
      }

      list.scrollLeft = 0;
      window.requestAnimationFrame(updateNav);
    }

    var observer = new MutationObserver(render);

    observer.observe(panelSummary, {
      attributes: true,
      attributeFilter: ['class']
    });

    [panelCount, panelSize, panelLast, panelDirection].forEach(function (element) {
      if (!element) return;

      observer.observe(element, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
    });

    window.addEventListener('resize', function () {
      render();
      updateNav();
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-gk-calc]').forEach(createVisualizer);
  }

  P.util.ready(initAll);
  document.addEventListener('shopify:section:load', initAll);
})(window, document);
